<template>
	<div @click="onClick" :class="{'is-mobile': $ui.isMobile, 'is-active': isActive}">
		<slot />
	</div>
</template>

<script>

export default {

	name: 'page-header',

	watch: {
		'$ui.isMobile'( isMobile ) {
			this.isActive = false
			document.body.classList.remove('has-mobileNavOpen')
		},
	},

	methods: {
		openNav() {
			let state = !document.body.classList.contains('has-mobileNavOpen');
			document.body.classList.toggle('has-mobileNavOpen', state)
		},
	},

	mounted() {
		document.querySelectorAll('.Header-toggle').forEach((element) => {
			element.addEventListener('click', this.openNav)
		})
	},

	data() {
		return {
			isActive: false,
		}
	},

}
</script>
